<template>
  <!--
      作者 gmshop
      时间：2020-06-09
      描述：会员-余额明细
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户ID">
          <el-input v-model="formInline.user_id" clearable="" placeholder="请输入会员id"></el-input>
        </el-form-item>
        <el-form-item label="选择月份"">
          <div class="block">
            <el-date-picker
              type="month"
              v-model="formInline.month"
              value-format="yyyy-MM"
              placeholder="选择月份">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.is_settled" placeholder="请选择" clearable>
            <el-option label="全部" value="-1"></el-option>
            <el-option label="未结算" value="0"></el-option>
            <el-option label="已结算" value="1"></el-option>
            
          </el-select>
        </el-form-item>
      
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="编号" width="80"></el-table-column>
         
          <el-table-column prop="u" label="用户">
            <template slot-scope="scope">
              <p v-if="scope.row.user">
                <span>{{scope.row.user.nickName}}</span>
              <span class="gray9">(用户ID：{{scope.row.user.user_id}})</span>
              </p>
              <p v-if="scope.row.user">{{scope.row.user.mobile}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="来源用户">
            <template slot-scope="scope">
              <p v-if="scope.row.downuser">
                <span>{{scope.row.downuser.nickName}}</span>
              <span class="gray9">(用户ID：{{scope.row.downuser.user_id}})</span>
              </p>
              <p v-if="scope.row.downuser">{{scope.row.downuser.mobile}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="业绩等级">
            <template slot-scope="scope">
              <span>{{scope.row.grade.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="log_time" label="月份	"></el-table-column>
          
          <!-- <el-table-column prop="performance" label="可奖励业绩	"></el-table-column> -->
          <el-table-column prop="total_performance" label="累计业绩	"></el-table-column>
          <el-table-column prop="dec_money" label="调整金额	">
            <template slot-scope="scope">
              <span v-if="scope.row.dec_money>0">+</span>
              <span>{{ scope.row.dec_money }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注	"></el-table-column>
          <el-table-column prop="is_settled" label="是否结算" width="130">
            <template slot-scope="scope">
              <span class="green" v-if="scope.row.is_settled==1">已结算</span>
              <span class="gray9" v-if="scope.row.is_settled==0">未结算</span>
            </template>
          </el-table-column>
          <el-table-column prop="award_money" label="已发奖励	"></el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button @click="openClick(scope.row)" type="text" size="small">查看明细</el-button>
              <el-button v-if="scope.row.is_settled==0" @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
              <el-button v-if="scope.row.is_settled==0" @click="settledClick(scope.row)" type="text" size="small">发放奖励</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  <Log v-if="open_log" :is_open="open_log" :log="log"  @closeDialog="closeDialogFunc($event)"></Log>
  <Edit v-if="open_edit" :open_edit="open_edit" :form="formModel"  @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

  </div>
</template>

<script>
  import UserApi from '@/api/user.js';
  import Log from './dialog/ProfitsLog.vue';
  import Edit from './dialog/Profitsedit.vue';
  export default {
    components: {
      Log,
      Edit
    },

    data() {
      return {
        open_log:false,
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 15,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          user_id: '',
          scene: '',
          value1: '',
          month: '',
          is_settled: '-1',
        },
        /*场景*/
        Scene: [],
        /*时间*/
        value1: '',
        log:{},
        open_edit: false,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();

    },
    methods: {

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        UserApi.ProfitsLog(Params, true).then(data => {
        //  console.log(data.data.list.data);
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.Scene = data.data.attributes.scene;
        }).catch(error => {

        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        this.curPage = 1;
        self.loading = true;
        let Params = self.formInline;
        self.getTableList();
      },
       /*打开添加*/
      openClick(item) {
        this.log = item;
        this.open_log = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.open_log = e.openDialog;
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      },
      /*打开编辑*/
      editClick(item) {
        this.formModel = item;
        this.open_edit = true;
      },
       /*发放培养奖励*/
       settledClick(item) {
        let self = this;
        self.$confirm('确认发放当前用户的培养奖励吗，操作不可撤销。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.loading = true;
          UserApi.sendProfits({
              id: item.id
            },
            true
          )
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.getData();
          })
          .catch(error => {
            self.loading = false;
          });
        }).catch(() => {});
        
      },


    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/user/user/profits.vue